import { render, staticRenderFns } from "./DocumentPortalSetupConfigureView.vue?vue&type=template&id=14c14537&scoped=true&"
import script from "./DocumentPortalSetupConfigureView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupConfigureView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSetupConfigureView.vue?vue&type=style&index=0&id=14c14537&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c14537",
  null
  
)

export default component.exports